export default class AccountMessage {

    constructor(cscom) {
        if (!(this instanceof AccountMessage)) {
            return new AccountMessage(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/account-messages/list', null, data);
    }
}
